import { FormProvider } from 'react-hook-form';
import { FormInput } from '@/components/form/form-input';
import { SmartSuggestionFormShell } from '@/features/inventory/pages/smart-suggestion/form-shell';
import { useGroupTypeForm } from '../../hooks/group-type-setting-hooks';

const GroupTypeForm = () => {
  const {
    id,
    form,
    isLoading,
    createMutation,
    editMutation,
    handleReset,
    handleDelete,
    onSubmit,
  } = useGroupTypeForm();

  return (
    <div className="space-y-6">
      <FormProvider {...form}>
        <SmartSuggestionFormShell
          id={id}
          title={id ? 'Edit Group Type' : 'New Group Type'}
          description="Offered as the group on a booking, for example School or Company outing."
          isLoading={!!id && isLoading}
          isSaving={createMutation.isPending || editMutation.isPending}
          onSubmit={form.handleSubmit(onSubmit)}
          onReset={handleReset}
          onDelete={handleDelete}
        >
          <FormInput
            name="name"
            label="Group Type Name"
            placeholder="e.g. School"
            required
          />
        </SmartSuggestionFormShell>
      </FormProvider>
    </div>
  );
};

export default GroupTypeForm;
